import axiosIns from '@/api/axios';

export const GET_ALL_DATA = (args) => {
	return axiosIns.get('/roles?' + args);
};

export const GET_MENUS = (args) => {
	return axiosIns.get('/roles/menus', args);
};

export const ADD_DATA = (args) => {
	return axiosIns.post('/roles/create', args);
};

export const UPDATE_DATA = (args) => {
	return axiosIns.put(`/roles/${args.id}`, args);
};

export const DETAIL_DATA = (args) => {
	return axiosIns.get(`/roles/${args.id}`);
};

export const DELETE_DATA = (id) => {
	return axiosIns.delete(`/roles/${id}`);
};
